import { useEffect, useCallback, useMemo } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import debounce from 'lodash.debounce';
import { getStoresList, productsSelector } from '../feature';
import { IGetStoreListDTO } from '@/models/products.model';

const useStoresSearch = (limit?: number) => {
  const dispatch = useAppDispatch();
  const { isLoading, error, storeList } = useAppState(productsSelector);

  const searchStores = useCallback(
    debounce((search?: string) => {
      if (isLoading) return;
      const requestDto: IGetStoreListDTO = {};
      if (search) {
        requestDto.title = search;
      }
      if (limit) {
        requestDto.limit = limit;
      }
      dispatch(getStoresList(requestDto));
    }, 1000),
    [limit],
  );

  useEffect(() => {
    searchStores();
  }, [searchStores]);

  return useMemo(
    () => ({
      storeList,
      isLoading,
      searchStores,
      error,
    }),
    [storeList, isLoading, error],
  );
};

export default useStoresSearch;
